(() => {
  if (window.__btkV2SystemComparisonLoaded) return;
  window.__btkV2SystemComparisonLoaded = true;

  const ROOT_SELECTOR = '[data-btk-v2-system-comparison]';

  function initCarousel(root) {
    const carousel = root.querySelector('[data-btk-v2-sc-carousel]');

    if (!carousel) return;

    const slides = Array.from(
      carousel.querySelectorAll('[data-btk-v2-sc-slide]')
    );

    const dots = Array.from(
      carousel.querySelectorAll('[data-btk-v2-sc-dot]')
    );

    if (!slides.length) return;

    let activeIndex = 0;
    let touchStartX = null;
    let touchStartY = null;

    function preloadImages() {
      slides.forEach((slide) => {
        const image = slide.querySelector(
          '.btk-v2-system-comparison__ingredient-image'
        );

        if (!image) return;

        image.loading = 'eager';

        if (
          typeof image.decode === 'function' &&
          !image.complete
        ) {
          image.decode().catch(() => {});
        }
      });
    }

    function showSlide(index) {
      if (index < 0 || index >= slides.length) return;

      activeIndex = index;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle(
          'is-active',
          slideIndex === activeIndex
        );
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;

        dot.classList.toggle('is-active', isActive);
        dot.setAttribute(
          'aria-selected',
          isActive ? 'true' : 'false'
        );
      });
    }

    function showNext() {
      const nextIndex =
        activeIndex + 1 >= slides.length
          ? 0
          : activeIndex + 1;

      showSlide(nextIndex);
    }

    function showPrevious() {
      const previousIndex =
        activeIndex - 1 < 0
          ? slides.length - 1
          : activeIndex - 1;

      showSlide(previousIndex);
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.index);

        if (Number.isNaN(index)) return;

        showSlide(index);
      });
    });

    carousel.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.touches[0];

        if (!touch) return;

        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      },
      { passive: true }
    );

    carousel.addEventListener(
      'touchend',
      (event) => {
        if (
          touchStartX === null ||
          touchStartY === null
        ) {
          return;
        }

        const touch = event.changedTouches[0];

        if (!touch) return;

        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;

        touchStartX = null;
        touchStartY = null;

        if (Math.abs(deltaX) < 45) return;
        if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

        if (deltaX < 0) {
          showNext();
        } else {
          showPrevious();
        }
      },
      { passive: true }
    );

    root.__btkV2SystemComparisonShowSlide = showSlide;

    preloadImages();
    showSlide(0);
  }

  function initSection(root) {
    if (
      !root ||
      root.dataset.btkV2SystemComparisonInitialized ===
        'true'
    ) {
      return;
    }

    root.dataset.btkV2SystemComparisonInitialized = 'true';

    initCarousel(root);
  }

  function initAllSections(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAllSections();
      }
    );
  } else {
    initAllSections();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      const root =
        event.target.matches?.(ROOT_SELECTOR)
          ? event.target
          : event.target.querySelector(ROOT_SELECTOR);

      if (root) {
        initSection(root);
      }
    }
  );

  document.addEventListener(
    'shopify:block:select',
    (event) => {
      const blockId =
        event.detail && event.detail.blockId;

      if (!blockId) return;

      const slide = document.querySelector(
        `${ROOT_SELECTOR} [data-btk-v2-sc-slide][data-block-id="${blockId}"]`
      );

      if (!slide) return;

      const root = slide.closest(ROOT_SELECTOR);

      if (
        !root ||
        typeof root.__btkV2SystemComparisonShowSlide !==
          'function'
      ) {
        return;
      }

      const index = Number(slide.dataset.index);

      if (Number.isNaN(index)) return;

      root.__btkV2SystemComparisonShowSlide(index);
    }
  );
})();